export default "__VITE_ASSET__CT3tupTB__"